import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38026efc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "incredicon-add-cloud" }, null, -1))
const _hoisted_3 = { class: "unlock-cloud-text text-[12px]" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "row" }

import { useMatomo } from '@/services/matomo/matomo.service';

import { IncrediButton, IncrediTooltip } from 'incredi-ui';
import { computed, inject, ref } from 'vue';
import { CLOUD_STATUS } from '@/views/settings/settingsCloud/cloud.const';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { openCloudRedirectUrl } from '@/views/settings/settingsCloud/settingsCloud.utils';
import { MatomoAgentsActions, MatomoCategories } from '@/services/matomo/matomo.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'cloud-unlock',
  setup(__props) {

const matomo = useMatomo();
const coordinatorService = inject(IKCoordinatorsService);

const GQL_commonData = useCommonDataQuery(() => ({ coordinatorId: coordinatorService?.selectedCoordinator.value || '' }));
const cloudStatus = computed(() => (GQL_commonData?.result?.value?.ibManagerEntities?.settings?.common?.cloud?.cloudStatus as CLOUD_STATUS) || CLOUD_STATUS.Disabled);

const showTooltip = ref(false);

const openCloudUrl = async () => {
  showTooltip.value = false;
  await openCloudRedirectUrl(coordinatorService?.selectedCoordinator.value || '', cloudStatus.value);
  matomo?.trackEvent({
    category: MatomoCategories.Agents,
    action: MatomoAgentsActions.ScaleToCloud,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IncrediTooltip), {
    modelValue: showTooltip.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showTooltip).value = $event)),
    hover: "",
    direction: "top-sticky-right",
    "offset-x": 0,
    "offset-y": 4,
    delay: 200
  }, {
    content: _withCtx(() => [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('settings.cloud.cloudDisabled.tooltipTextA')), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('settings.cloud.cloudDisabled.tooltipTextB')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(IncrediButton), {
        class: "cloud-button",
        design: "primary-purple",
        size: "small",
        "data-testid": "agent-nav-bar--cloud-button",
        onClick: openCloudUrl
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('settings.cloud.cloudDisabled.button')), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})